import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import Modal from "../../../../../shared/modal/modal";
import styles from "./modal-successful-approve-krookie.module.scss";
import successIcon from "../../../../../images/success.svg";
import Button from "../../../../ui-kit/button/button";
import facebook from "../../../../../images/facebook.svg";
import instagram from "../../../../../images/instagram.svg";
import linkedin from "../../../../../images/linkedin.svg";
import x from "../../../../../images/x.svg";
import QrCode from "../../../../../shared/qr-code/qr-code";
import { GetKrookieDoc } from "../../../../../services/api";
import { useAppSelector } from "../../../../../hooks/useAppSelector";

interface ModalSuccessfulApproveKrookieProps {
  onClose: () => void;
}

const ModalSuccessfulApproveKrookie: FC<ModalSuccessfulApproveKrookieProps> = ({
  onClose,
}) => {
  const { convertedKrookieData } = useAppSelector(
    (state) => state.masterPlanModification,
  );

  const { t } = useTranslation();

  const krookies = Object.values(convertedKrookieData.krookies);

  const plotNumbers = krookies.map((krookie) => krookie.plotNumber);
  const plotNumberDisplay = plotNumbers.join(", ");

  let approvalMessage;
  if (krookies.length > 1) {
    approvalMessage = t("modalSuccessfulApproveKrookie.approvalMessageMultiple");
  } else {
    approvalMessage = t("modalSuccessfulApproveKrookie.approvalMessage", {
      serial: krookies[0].serial,
    });
  }

  const handlePrintDocument = async () => {
    for (const krookie of krookies) {
      await GetKrookieDoc(krookie.id);
    }
    onClose()
  };

  return (
    <Modal onClose={onClose}>
      <div className={styles.modalSuccessful}>
        <div className={styles.title}>
          {t("modalSuccessfulApproveKrookie.plotNumber")}: {plotNumberDisplay}
        </div>
        <div className={styles.body}>
          <img
            src={successIcon}
            alt={t("modalSuccessfulApproveKrookie.successAlt")}
          />
          <div className={styles.description}>{approvalMessage}</div>
          {/*<div className={styles.social}>*/}
          {/*  <p>{t("modalSuccessfulApproveKrookie.shareLabel")}</p>*/}
          {/*  <div className={styles.links}>*/}
          {/*    <img*/}
          {/*      className={styles.imgLink}*/}
          {/*      src={x}*/}
          {/*      alt={t("modalSuccessfulApproveKrookie.xAlt")}*/}
          {/*    />*/}
          {/*    <img*/}
          {/*      className={styles.imgLink}*/}
          {/*      src={facebook}*/}
          {/*      alt={t("modalSuccessfulApproveKrookie.facebookAlt")}*/}
          {/*    />*/}
          {/*    <img*/}
          {/*      className={styles.imgLink}*/}
          {/*      src={linkedin}*/}
          {/*      alt={t("modalSuccessfulApproveKrookie.linkedinAlt")}*/}
          {/*    />*/}
          {/*    <img*/}
          {/*      className={styles.imgLink}*/}
          {/*      src={instagram}*/}
          {/*      alt={t("modalSuccessfulApproveKrookie.instagramAlt")}*/}
          {/*    />*/}
          {/*    {krookies.length === 1 && krookies[0].qrCodeLink && (*/}
          {/*      <QrCode*/}
          {/*        sizeQr={32}*/}
          {/*        href={krookies[0].qrCodeLink}*/}
          {/*        qrOnly={true}*/}
          {/*      />*/}
          {/*    )}*/}
          {/*  </div>*/}
          {/*</div>*/}
          <Button
            onClick={handlePrintDocument}
            className={styles.btn}
            type="primary"
          >
            {t("modalSuccessfulApproveKrookie.printButton")}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ModalSuccessfulApproveKrookie;
